<template>
    <transition name="overlay">
    <!--    <h2 class="title" v-if="!success">Заказ бесплатного замера</h2>-->
        <p class="h3 form__success" v-if="success">
            <img class="form__success-img" src="/assets/img/other/snail.png" alt="">
            <span class="form__success-text">
                            Заявка успешно отправлена! Мы свяжемся с Вами в ближайшее время.
                        </span>
        </p>
        <form v-if="!success" class="free-measurement-form__form-wrap" @submit.prevent="formSubmit" >
            <div class="free-measurement-form__form-title">
                Заказать замер
            </div><!--
            <input
                type="text"
                class="input__text free-measurement-form__form-input"
                placeholder="Ваше имя"
                v-model="order.name"
            > -->
            <input-text
                v-model="order.name"
                :v="$v.order.name"
                placeholder="Ваше имя"
                errorText="Укажите ваше имя"/>
            <input-phone
                v-model="order.phone"
                :v="$v.order.phone"
                errorText="Укажите корректный номер"
                placeholder="+7-987-766-7665"/>
            <select  v-model="order.city" value="Новосибирск" class="input__text free-measurement-form__form-input" placeholder="Укажите область">
                <option v-for="cityOption in cities" v-bind:value="cityOption">{{cityOption}}</option>
    <!--            <option value="Новосибирск">Новосибирск</option>-->
    <!--            <option value="Томск">Томск</option>-->
    <!--            <option value="Кемерово">Кемерово</option>-->
            </select>
    <!--        <div class="input">-->
    <!--            <v-select :options="cities"-->
    <!--                      :multiple="false"-->
    <!--                      :searchable="false"-->
    <!--                      v-model="order.city"-->
    <!--                      @change="$v.order.city.$touch()"-->
    <!--                      @blur="$v.order.city.$touch()"-->
    <!--                      required-->
    <!--                      placeholder="Укажите область"-->
    <!--                      class="input__text free-measurement-form__form-input">-->
    <!--            </v-select>-->
    <!--            <span class="input__error" v-if="$v.order.city.$error">Укажите область</span>-->
    <!--        </div>-->
    <!--        <input-->
    <!--            type="datatime"-->
    <!--            class="input__text free-measurement-form__form-input"-->
    <!--            v-model="order.date"-->
    <!--        >-->
            <input-date
                v-model="order.date"
                :v="$v.order.date"
                placeholder="Выберите удобную дату"
                errorText="Укажите дату"/>
            <custom-checkbox
                :v="$v.order.politics"
                v-model="order.politics"
                :class="{_error: $v.order.politics.$error}"
                checkboxName="politicsPayment"
                checkboxText="Я согласен на обработку персональных данных"/>

            <button type="submit" class="btn free-measurement-form__form-btn">
                Отправить
            </button>
        </form>
    </transition>
</template>

<script>
import customCheckbox from './common/custom-checkbox';
import inputText from "./common/inputText";
import inputDate from "./common/inputDate";
import inputPhone from "./common/inputPhone";
import {maxLength, minLength, required, sameAs} from "vuelidate/lib/validators";

export default {
    name: 'orderForm',
    components: {
        inputText,
        inputPhone,
        inputDate,
        customCheckbox,
    },
    data() {
        return {
            order: {
                phone: null,
                name: null,
                city: null,
                date: null,
                recaptcha: null,
                url: null,
                type: 'measurement',
                politics: true
            },
            cities: this.$store.state.cities,
            success: false,
        }
    },
    methods:{
        formCheck() {
            console.log(this.order);
            if(this.order.name && this.order.phone &&
                this.order.city && this.order.date && this.order.politics){
                console.log('mounted', this.order);
            }
        },
        formSubmit() {
            this.$v.order.$touch();
            if (this.$v.order.$pending || this.$v.order.$error) {

            } else {
                this.recaptcha().then(token => {
                    this.order.recaptcha = token;
                    this.order.url = window.location.href;
                    this.$http.post('/api/forms/callback', this.order).then(res => {

                    })
                    this.success = true;
                    ym(1980352,'reachGoal','promoOrder')
                });
            }
        },
    },
    validations: {
        order: {
            name: {
                required,
                minLength: minLength(2)
            },
            city: {required},
            date: {},
            politics: {
                sameAs: sameAs(() => true)
            },
            phone: {
                required,
                minLength: minLength(18),
                maxLength: maxLength(18),
                correctAddress(phone) {
                    return /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/.test(phone)
                }
            }
        }
    },

    mounted () {
        console.log('mounted', this.order);
    },
};
</script>
